export default __webpack_public_path__ + "static/media/afficheBlur.c84bfd27.jpg";